/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Specifies the field for sorting an analysis
 */
export interface TableSort { 
    /**
     * Primary Key
     */
    id?: number;
    /**
     * Specifies the field for default sorting
     */
    standardSorting?: string;
    /**
     * Indicates the selected field for sorting
     */
    choosenSorting?: string;
    /**
     * Contains a 1 for Ascending sort and -1 for Descending sort
     */
    sortOrder?: number;
}

